module.exports = __webpack_public_path__ + "img/microcaps.3f17a05d.png";